import { FormTypes } from 'constants/formTypes';
import React from 'react';
import i18n from 'util/i18n';

export type FormChoicesForm = {
  createdDate: string;
  externalId: string;
  formType: FormTypes;
  formVersion: string;
  orgName: string;
  pocEmail: string;
  pocName: string;
  status: string;
};

export type FormChoicesProps = {
  forms: FormChoicesForm[];
  onFormSelection: (form: FormChoicesForm) => void;
};

// TODO: Resolve the conflict between the lint rule and the format on save.
// eslint-disable-next-line func-names
const FormChoices = function (props: FormChoicesProps) {
  const forms: FormChoicesForm[] = props.forms || [];

  const { onFormSelection } = props;

  return (
    <div className="form-choices">
      <p
        className="form-choices-description"
      >
        {/* The National Background Investigation Services (NBIS) eApp system [...] */}
        {i18n.t('formChoices.description')}
      </p>
      {/* My Forms */}
      <h2 className="form-choices-title2">
        {i18n.t('formChoices.title2')}
      </h2>
      <hr className="form-choices-hr" />
      <p
        className="form-choices-instructions"
      >
        {/* Review the forms assigned to you below. [...] */}
        {i18n.t('formChoices.instructions')}
      </p>
      <div className="form-card-row">
        {forms.map((form, index) => (
          <div
            className="form-card"
            key={index}
          >
            <div className="form-card-details">
              {/* Form Name */}
              <p>
                <span className="form-choices-label">
                  {i18n.t('formChoices.formName')}
                </span>
                <span className="form-choices-value">
                  {form.formType}
                </span>
              </p>
              {/* Form Version */}
              <p>
                <span className="form-choices-label">
                  {i18n.t('formChoices.formVersion')}
                </span>
                <span className="form-choices-value">
                  {form.formVersion}
                </span>
              </p>
              {/* Status */}
              <p>
                <span className="form-choices-label">
                  {i18n.t('formChoices.status')}
                </span>
                <span className="form-choices-value">
                  {form.status}
                </span>
              </p>
              {/* Point of Contact */}
              <p>
                <span className="form-choices-label">
                  {i18n.t('formChoices.pocName')}
                </span>
                <span className="form-choices-value">
                  {form.pocName}
                </span>
              </p>
              {/* Point of Contact Email */}
              <p>
                <span className="form-choices-label">
                  {i18n.t('formChoices.pocEmail')}
                </span>
                <span className="form-choices-value">
                  {form.pocEmail}
                </span>
              </p>
              {/* Organization */}
              <p>
                <span className="form-choices-label">
                  {i18n.t('formChoices.orgName')}
                </span>
                <span className="form-choices-value">
                  {form.orgName}
                </span>
              </p>
              {/* Date Added */}
              <p>
                <span className="form-choices-label">
                  {i18n.t('formChoices.createdDate')}
                </span>
                <span className="form-choices-value">
                  {form.createdDate}
                </span>
              </p>
            </div>
            <div
              className="form-choices-card-button-container"
            >
              <button
                aria-label={`${i18n.t('formChoices.select')} ${form.formType}`}
                onClick={() => onFormSelection(form)}
                onKeyPress={() => onFormSelection(form)}
                type="button"
              >
                {i18n.t('formChoices.select')} {form.formType}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FormChoices;
